module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-footer flex-box"
  }, [_c('div', {
    staticClass: "g-navs",
    class: _vm.on('index') ? 'c-on' : '',
    on: {
      "click": function($event) {
        return _vm.changeTab('/index')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dangjian"
  }), _vm._v(" "), _c('p', [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "g-navs",
    class: _vm.on('informationIndex') ? 'c-on' : '',
    on: {
      "click": function($event) {
        return _vm.changeTab('/informationIndex')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zixun"
  }), _vm._v(" "), _c('p', [_vm._v("资讯")])]), _vm._v(" "), _c('div', {
    staticClass: "g-navs",
    class: _vm.on('schoolAndCourse') ? 'c-on' : '',
    on: {
      "click": function($event) {
        return _vm.changeTab('/schoolAndCourse')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xuexiao"
  }), _vm._v(" "), _c('p', [_vm._v("党校")])]), _vm._v(" "), _c('div', {
    staticClass: "g-navs",
    class: _vm.on('activityList') ? 'c-on' : '',
    on: {
      "click": function($event) {
        return _vm.changeTab('/activityList')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-partycommittee"
  }), _vm._v(" "), _c('p', [_vm._v("活动")])]), _vm._v(" "), _c('div', {
    staticClass: "g-navs",
    class: _vm.on('mine') ? 'c-on' : '',
    on: {
      "click": function($event) {
        return _vm.changeTab('mine')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dangwei"
  }), _vm._v(" "), _c('p', [_vm._v("我的")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-daf01da8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 228
// module chunks = 49